function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{display:none;fill:#D40005;}\n\t.st1{display:none;fill:#FF0A18;}\n");

var _ref3 = /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "16.2,4.8 32.6,-1.2 33.9,2.6 19.3,7.9 "
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "18.4,3.9 28.2,0.4 29.6,4.1 21.6,7.1 "
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "10.4,11.1 0.1,14.9 -1.3,11.1 10.5,6.8 "
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  points: "8.4,11.9 1.4,14.4 0,10.6 8.4,7.6 "
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5,1.1c-0.3,0-0.5,0.2-0.5,0.5v32.8c0,0.3,0.2,0.5,0.5,0.5c0.1,0,0.3,0,0.4-0.1l9.7-9.7h13c0.3,0,0.5-0.2,0.5-0.5 c0-0.1,0-0.3-0.1-0.4L12,1.3C11.9,1.2,11.7,1.1,11.5,1.1z"
});

var SvgEdgeSelect = function SvgEdgeSelect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdgeSelect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EdgeSelect.b15e62bb.svg";
export { ForwardRef as ReactComponent };